import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const initialState = {
  isAuthenticated: false,
  forgotPasswordState: null,
  validateTokenResponseState: null,
  setPasswordState: null,
  loading: false,
  validateEstimateResponseState: null,
};

const HomePageSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    login(state) {
      state.loading = true;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.isAuthenticated = !!action.payload.token;
      const selectedCompany = localStorage.getItem("CompanyId");
      const lastVisitedPath = localStorage.getItem("lastVisitedPath");
      state.token = JSON.stringify(action.payload.token);
      localStorage.setItem("isAuthenticated", state.isAuthenticated);
      localStorage.setItem("token", state.token);
      localStorage.setItem("token_bearer", action.payload.token);
      localStorage.setItem("token_type", action.payload.token_Type);
      if (lastVisitedPath) {
        localStorage.setItem("lastVisitedPath", lastVisitedPath);
      }
      const decoded = jwtDecode(action.payload.token);
      if (decoded) {
        state.user = JSON.stringify(decoded);
        localStorage.setItem("user", JSON.stringify(decoded));
        localStorage.setItem("userName", decoded.displayname);
        localStorage.setItem("userId", decoded.userid);
        localStorage.setItem("roleId", decoded.roleid);
        localStorage.setItem("Accesses", JSON.stringify(decoded.accesses));
      }
    },
    loginFailure(state) {
      state.loading = false;
      state.isAuthenticated = false;
    },
    forgotPasswordSuccess(state, action) {
      state.forgotPasswordState = action.payload;
    },
    forgotPasswordFailure(state, action) {
      state.forgotPasswordState = action.payload;
    },
    resetForgotPasswordState(state) {
      state.forgotPasswordState = null;
    },
    validateTokenResponse(state, action) {
      state.validateTokenResponseState = action.payload;
    },
    setPasswordSuccess(state, action) {
      state.setPasswordState = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetForgotPasswordState,
  validateTokenResponse,
  setPasswordSuccess,
} = HomePageSlice.actions;

export default HomePageSlice.reducer;
